import api from './api';

// Relations
const getRelations = () => api.get('/relation/relations/');
const getRelation = (relationId) => api.get(`/relation/relations/${relationId}/`);
const createRelation = (data) => api.post('/relation/relations/', data);
const updateRelation = (relationId, data) => api.put(`/relation/relations/${relationId}/`, data);
const deleteRelation = (relationId) => api.delete(`/relation/relations/${relationId}/`);

export {
    getRelations,
    getRelation,
    createRelation,
    updateRelation,
    deleteRelation,
};